import React from 'react'
import PropTypes from 'prop-types'
import LayoutSuspense from 'layouts/LayoutSuspense'

const CustomLayout = ({ children }) => {
  return <LayoutSuspense>{children}</LayoutSuspense>
}

export default CustomLayout

CustomLayout.propTypes = {
  props: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.element),
    PropTypes.element,
    PropTypes.oneOf([null]),
  ]).isRequired,
}
